import { render, staticRenderFns } from "./BookingsFilterPanel.vue?vue&type=template&id=212cb9a4"
import script from "./BookingsFilterPanel.vue?vue&type=script&lang=js"
export * from "./BookingsFilterPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports